import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import BackButton from "../components/microComponents/BackButton";
import CourseApi from "../api/services/CourseApi";
import Urls from "../api/Urls";
import StatisticsCard, {
  StatisticsCardSkeleton,
} from "../components/StatisticsCard/StatisticsCard";

const Statistiche = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [chapters, setChapters] = useState<any[]>([]);

  useEffect(() => {
    getChapters();
  }, []);

  const getChapters = () => {
    setIsLoading(true);

    CourseApi.getStatictics({
      onSuccess: (response) => {
        setIsLoading(false);
        setChapters(response.data);
      },
      onError: () => setIsLoading(false),
    });
  };

  const resetAll = () => {
    const confirmed = window.confirm(
      "Reset statistiche?\nThis request will permanently delete your statistical record. Are you sure you want to reset all your statistical data?"
    );

    if (confirmed) {
      CourseApi.resetStatictics({
        onSuccess: (response) => {
          setChapters([]);
        },
        onError: (error) => console.log(error),
      });
    }
  };

  const reset = (id: number) => {
    const confirmed = window.confirm(
      "Reset statistiche?\nThis request will permanently delete your statistical record. Are you sure you want to reset all your statistical data?"
    );
    if (confirmed) {
      CourseApi.resetStaticByChapterId(id, {
        onSuccess: (response) => {
          // Refresh the data after reset
          getChapters();
        },
        onError: (error) => console.log(error),
      });
    }
  };

  const loading_skeleton = () => {
    return (
      <Row className="statistiche">
        {Array.from({ length: 4 }).map((_, index) => (
          <Col className="item_col" xs={12} md={6} key={index}>
            <StatisticsCardSkeleton />
          </Col>
        ))}
      </Row>
    );
  };

  // console.log("chapters", chapters);
  return (
    <div className="Container pb-4">
      <div className="statistiche_main">
        <div className="titleSec">
          <BackButton title={"Statistiche"} />
          <button className="btnr sm warning" onClick={resetAll}>
            Reset-All
          </button>
        </div>

        {isLoading ? (
          loading_skeleton()
        ) : (
          <Row className="statistiche">
            {chapters.map((item) => (
              <Col className="item_col" xs={12} md={6} key={item.id}>
                <StatisticsCard
                  imageSource={Urls.storagePath + item?.media?.file_path}
                  id={item.id}
                  name={item.chapter_name_italian}
                  totalQuize={item.total_quiz}
                  correct={item.total_correct}
                  error={item.total_error}
                  noAnswer={item.not_answer}
                  onResetPress={() => reset(item.id)}
                />
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
};

export default Statistiche;
